import { apiGet, apiPost } from './index'
// 获取医生旅程报告AIFV信息
const getAIFVReport = (params) => apiGet(`/api/hcp/journey/reports/report/aifv/multicode/${params.multiCode}`, params)
// 获取医生旅程报告AIFV信息
const getAIFVFileList = (params) => apiGet(`/api/hcp/operation/reports`, params)
// 获取AIFV PDF
const getAIFVPDF = (params) => apiGet(`/api/sys-files/${params.fileId}`, params)
// 获取AIFV 信息
const getAifvInfo = (params) => apiGet(`/api/aifvModalContent/getAifvInfo/${params.multiCode}`, params)
// 获取模拟器单页信息
const getSimulatorOnePage = (params) => apiGet(`/api/aifvModalContent/getSimulatorOnePage/${params.multiCode}`, params)
// 员工术者关系
const getEmployeeHcp = (params) => apiGet(`/api/employeeHcp`, params)
// 是否推荐
const aifvPushRecord = (params) => apiPost(`/api/aifvPushRecord`, params)
// 是否推荐
const queryPdf = (params) => apiGet(`/api/hcp/operation/reports/queryPdf/${params.operationId}`, params)
// 是否推荐
const getInfoByMultiCode = (params) => apiGet(`/api/employeeHcp/info/${params.multiCode}`)

export {
  getAIFVReport,
  getAIFVFileList,
  getAIFVPDF,
  getAifvInfo,
  getSimulatorOnePage,
  getEmployeeHcp,
  aifvPushRecord,
  queryPdf,
  getInfoByMultiCode
}



// WEBPACK FOOTER //
// ./src/api/aifv.js